import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'advertiserKey',
  storage: sessionStorage,
});

export interface AdvertiserInfo {
  name?: string;
  key?: string;
  number?: number;
  status?: string;
  manager_name?: string;
  manager_tel?: string;
  manager_email?: string;
  id?: number | null;
}

export const advertiserAtom = atom<AdvertiserInfo[]>({
  key: 'advertiserData',
  default: [],
  effects_UNSTABLE: [persistAtom],
});

export const selectedRoleAtom = atom({
  key: 'selectedRole',
  default: 1,
});
